import { Button, SxProps, Theme } from "@mui/material";
import { useEffect, useState } from "react";
import OpenComponentDialog from "src/components/shared-components/modal/openComponentModal";
import PrintModal from "./modal";
import { useTranslate } from "src/locales";

//MPOGLU;443876;19022025
interface ByzMuiPrintButtonProps {
  type: 1 | 2 | 3; // type prop'u yalnızca 1, 2 veya 3 değerlerini alabilir
  sx?: SxProps<Theme>; // sx prop'u eklendi
  disabled?: boolean;
  onClick?: () => void; // Custom click handler
}

const ByzMuiPrintButton = ({ type, sx, disabled = false, onClick }: ByzMuiPrintButtonProps) => {
  const [dialogState, setDialogState] = useState<{
    open: boolean;
    type: number;
  } | null>(null);
  const [currentPrintRow, setCurrentPrintRow] = useState<any>(null);

  const handleOpenDialog = (type: number) => {
    if (disabled) return;
    if (onClick) {
      onClick();
      return;
    }
    setDialogState({ open: true, type });
  };

  const handleCloseDialog = () => {
    setDialogState(null);
    setCurrentPrintRow(null);
  };

  // İkonun src değerini type'a göre ayarlıyoruz
  const iconSrc =
    type === 1
      ? "/assets/icons/print/print.svg"
      : type === 2
        ? "/assets/icons/print/save-ass.svg"
        : "/assets/icons/print/save-view.svg";

  const { t } = useTranslate();

  // Title'ı type'a göre belirliyoruz
  const dialogTitle =
    type === 1 ? t("print.print") : type === 2 ? t("print.save-ass") : t("print.save-view");

  return (
    <>
      <Button
        onClick={() => handleOpenDialog(type)}
        variant="contained"
        disabled={disabled}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          border: "1px solid #2196F3",
          borderRadius: "50%",
          backgroundColor: "transparent",
          padding: "12px",
          marginLeft: "2px",
          fontSize: "14px",
          fontWeight: 600,
          textTransform: "uppercase",
          "&:hover": {
            backgroundColor: "#2196F3",
            "& img": {
              filter: "brightness(0) invert(1)", // Hover durumunda ikonun rengini beyaz yap
            },
          },
          ...sx, // Gelen sx'i merge ediyoruz
        }}
      >
        <img
          src={iconSrc} // İkonun src değerini burada kullanıyoruz
          alt="print icon"
          style={{
            width: "90%",
            height: "90%",
            maxWidth: "32px",
            maxHeight: "32px",
          }}
        />
      </Button>

      {/* Dialog'u dinamik olarak render ediyoruz */}
      {dialogState && (
        <OpenComponentDialog
          title={dialogTitle} // Title'ı type'a göre veriyoruz
          open={dialogState.open}
          onClose={handleCloseDialog}
          isMedCard={false}
          PaperProps={{
            sx: {
              width: "100%",
              maxWidth: { xs: "90%", sm: "70%", md: "50%", lg: "20%" },
              borderRadius: "8px",
              boxShadow: 3,
            },
          }}
        >
          <PrintModal type={type} onClose={handleCloseDialog} />
        </OpenComponentDialog>
      )}
    </>
  );
};

export default ByzMuiPrintButton;
